import React from 'react'

function Mission() {
    return (
        <section className='mission'>
            <h2>Our Mission</h2>
            <p>
                At FitForge, our mission is to empower individuals to achieve their fitness aspirations through personalized training, cutting-edge facilities, and a supportive community. We believe in fostering a culture of growth, resilience, and well-being, where every member feels motivated and equipped to
                reach their full potential.</p>

        </section>
    )
}

export default Mission
